module.exports = __webpack_public_path__ + "static/daw_req-4ec0c36ccb8d37d42c7ed282e1a93634.png";